<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Term Comment" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select :loading="loading" item-value="id" item-text="name" single-line v-model="TermComment.TermId" outlined :hide-details="termErrors.length === 0" dense :error-messages="termErrors" :items="terms" label="Select Term"></v-select>
          </v-col>
          <v-col cols="12">
            <v-select :loading="loading" item-value="id" item-text="fullName" single-line v-model="TermComment.StudentId" outlined :hide-details="studentErrors.length === 0" dense :error-messages="studentErrors" :items="students" label="Select Student"></v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea v-model="TermComment.comment" :hide-details="commentErrors.length === 0" :error-messages="commentErrors"
            label="Comment" dense outlined ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import termCommentService from "../service.js";
import termService from "@/modules/ReportCard/Terms/service.js";
import studentService from "@/modules/Student/service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTermComment: {
      type: Object,
    },
  },
  name: "update-term-comment",
  data() {
    return {
      loading: false,
      dialog: false,
      terms: [],
      students: [],
      TermComment: {
        comment: null,
        TermId: null,
        StudentId: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    TermComment: {
      comment: {
        required,
      },
      TermId: {
        required,
      },
      StudentId: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    commentErrors() {
      const errors = [];
      if (!this.$v.TermComment.comment.$dirty) return errors;
      if (!this.$v.TermComment.comment.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    termErrors() {
      const errors = [];
      if (!this.$v.TermComment.TermId.$dirty) return errors;
      if (!this.$v.TermComment.TermId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    studentErrors() {
      const errors = [];
      if (!this.$v.TermComment.StudentId.$dirty) return errors;
      if (!this.$v.TermComment.StudentId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.TermComment = JSON.parse(JSON.stringify(this.editTermComment));
      this.dialog = val;
      if(val)
        this.getTerm()
        this.getStudent()
    },
  },
  methods: {
    getTerm() {
      this.loading = true;
      termService.getAll().then(response => {
        
        this.loading = false;
        this.terms = response.data
        console.log('term', this.terms)
      }).catch(error => {
        this.loading = false;
        console.log('error getting term', error)
      })
    },
    getStudent() {
      this.loading = true;
      studentService.getAll().then(response => {
        
        this.loading = false;
        this.students = response.data
        console.log('student', this.students)
      }).catch(error => {
        this.loading = false;
        console.log('error getting student', error)
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.TermComment = {
        comment: null,
        TermId: null,
        StudentId: null
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return termCommentService
          .update(this.TermComment.id, this.TermComment)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Term Comment is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
